import React from 'react'
import { apiFetch } from '../../../../fetchApi';

export const createCertificate = ({ BeURL, certifications, setCertificate, showAlert, candidateId }) => {

    apiFetch(`${BeURL}/candidate-certificate`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ certifications, candidateId }),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setCertificate(data.certificate)
                window.location.reload()

            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in create certifications", err);
        });
}
